<template>
    <div>
        <div
            class="tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-border-gray-100 tw-overflow-hidden"
            style="height: 36vh;"
        >
            <div
                class="tw-bg-gradient-to-r tw-from-purple-900 tw-to-purple-600 tw-px-4 tw-py-2"
            >
                <div
                    class="tw-text-md tw-font-semibold tw-text-white tw-flex tw-items-center tw-uppercase"
                >
                    <svg
                        class="tw-w-5 tw-h-5 tw-mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    Customer Info
                </div>
            </div>

            <div class="tw-p-6">
                <div class="tw-flex tw-items-start tw-space-x-6">
                    <!-- Customer Avatar -->
                    <div class="tw-flex-shrink-0">
                        <div
                            class="tw-w-24 tw-h-24 tw-bg-gray-200 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
                        >
                            <img
                                class="w-12 h-12 tw-border-4 tw-border-gray-800 tw-rounded-full"
                                v-lazy="{
                                    src: photo(customer),
                                    error: onError(customer),
                                    loading: require('@/assets/Rolling-1s-200px.svg'),
                                    preLoad: 1.3,
                                    attempt: 1
                                }"
                            />
                        </div>
                        <div class="tw-text-center tw-mt-2">
                            <span class="tw-text-sm tw-text-gray-500">{{
                                customer ? customer.customer_code : "-"
                            }}</span>
                        </div>
                    </div>

                    <!-- Customer Details -->
                    <div
                        class="tw-flex-1 tw-grid tw-grid-cols-1 tw-md:tw-grid-cols-2 tw-gap-4"
                    >
                        <div class="tw-space-y-3">
                            <div>
                                <label
                                    class="tw-text-sm tw-font-medium tw-text-gray-500"
                                    >{{ $t("loanDisbursement.nameKh") }}</label
                                >
                                <p class="tw-text-gray-900 tw-font-medium">
                                    {{
                                        customer
                                            ? customer.customer_name_kh
                                            : "-"
                                    }}
                                </p>
                            </div>
                            <div>
                                <label
                                    class="tw-text-sm tw-font-medium tw-text-gray-500"
                                    >{{ $t("loanDisbursement.nameEn") }}</label
                                >
                                <p class="tw-text-gray-900 tw-font-medium">
                                    {{
                                        customer
                                            ? customer.customer_name_en
                                            : "-"
                                    }}
                                </p>
                            </div>
                        </div>
                        <div class="tw-space-y-3">
                            <div>
                                <label
                                    class="tw-text-sm tw-font-medium tw-text-gray-500"
                                    >{{
                                        $t("loanDisbursement.contactNo")
                                    }}</label
                                >
                                <p class="tw-text-gray-900 tw-font-medium">
                                    {{ customer ? customer.contact_no : "-" }}
                                </p>
                            </div>
                            <div>
                                <label
                                    class="tw-text-sm tw-font-medium tw-text-gray-500"
                                    >{{ $t("loanDisbursement.address") }}</label
                                >
                                <p class="tw-text-gray-900 tw-font-medium">
                                    <small>
                                        {{
                                            customer
                                                ? customer.village
                                                    ? customer.village.name_en +
                                                      ", "
                                                    : ""
                                                : ""
                                        }}
                                        {{
                                            customer
                                                ? customer.commune
                                                    ? customer.commune.name_en +
                                                      ", "
                                                    : ""
                                                : ""
                                        }}
                                        {{
                                            customer
                                                ? customer.district
                                                    ? customer.district
                                                          .name_en + ", "
                                                    : ""
                                                : ""
                                        }}
                                        {{
                                            customer
                                                ? customer.province
                                                    ? customer.province
                                                          .name_en + "."
                                                    : "-"
                                                : "-"
                                        }}
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
    name: "customerInfo",
    props: ["value"],
    data() {
        return {
            model: {},
            errors: new Errors()
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("creditOperation/loanRepayment", ["loanDisbursements"]),
        customer() {
            if (this.loanDisbursements.length > 0 && this.model.loan_id) {
                return this.loanDisbursements.find(
                    l => l.loan_id == this.model.loan_id
                ).customer;
            }
            return [];
        }
    },
    methods: {
        photo(record) {
            if (record) {
                return record.photo;
            }

            return require("@/assets/staff-default-man.png");
        },
        onError(record) {
            if (record) {
                return record.gender == "Male"
                    ? require("@/assets/staff-default-man.png")
                    : require("@/assets/staff-default-women.png");
            }

            return require("@/assets/staff-default-man.png");
        }
    }
};
</script>
<style scoped>
.cover {
    opacity: 0.2;
}
#cover-image img {
    object-fit: contain;
    width: 100%;
}
#img-frame {
    display: block;
    position: relative;
    margin-top: -40%;
}
#img-frame img {
    object-fit: contain;
    width: 117.84px;
    height: 150.92px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 3px;
    margin: 0 auto;
}
.widget-list .widget-list-item .widget-list-media,
.widget-list .widget-list-item .widget-list-content,
.widget-list .widget-list-item .widget-list-action {
    padding: 8px 0;
}
</style>
